import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class PrimeNGTranslationService {
  private readonly translateService = inject(TranslateService);
  private readonly primeNG = inject(PrimeNG);

  constructor() {
    this.updateTranslations();

    this.translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.updateTranslations();
      });
  }

  private updateTranslations(): void {
    this.translateService.get('primeng').subscribe((translations) => {
      if (translations) {
        this.primeNG.setTranslation(translations);
      }
    });
  }
}


